var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaleDecoration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 333.7,
    height: 108,
    viewBox: "0 0 333.7 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SHORTEST_frame",
    "data-name": "SHORTEST frame",
    transform: "translate(-4.7 -0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M282.7,55.1c-.6-.3-1.2-.7-1.8-1,.6-.3,1.2-.7,1.8-1a144.887,144.887,0,0,0,22.7-16.8l1.6-1.5-1.2-1.7a98.839,98.839,0,0,1-9-15.3l-1.6-3.5L292.3,17a16.6,16.6,0,0,0-1.4,1.3,27.336,27.336,0,0,0,0,7c.8-.7,1.7-1.4,2.5-2.1a103.274,103.274,0,0,0,6.6,11,137.392,137.392,0,0,1-17.8,13.3c-2.1,1.3-4.3,2.6-6.4,3.8a28.1,28.1,0,0,1,.1,2.9,27.148,27.148,0,0,1-.1,2.9c2.2,1.2,4.3,2.5,6.4,3.8A137.392,137.392,0,0,1,300,74.2a110.385,110.385,0,0,0-6.6,11c-.8-.7-1.7-1.4-2.5-2.1a32.76,32.76,0,0,0,0,7,16.605,16.605,0,0,1,1.4,1.3l2.9,2.7,1.6-3.5a94.368,94.368,0,0,1,9-15.3l1.2-1.7-1.6-1.5A140,140,0,0,0,282.7,55.1Z",
    fill: "#d2d4c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M299.8,62.6c9.3-5.1,33.6-8.2,38.6-8.5-5-.3-29.3-3.4-38.6-8.5-1.4,1.2-2.8,2.3-4.3,3.4A35.152,35.152,0,0,0,307,54.1a37.117,37.117,0,0,0-11.5,5.1C297,60.3,298.4,61.4,299.8,62.6Z",
    fill: "#d2d4c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M278.2,34.5c.2-.1.3-.2.5-.3.5-.3.9-.6,1.4-.9a41.767,41.767,0,0,1-.9-5.8c-1,.7-2.1,1.4-3.1,2.1-.1.1-.3.2-.4.3l-10.4,6.9V71.3l10.4,6.9c.1.1.3.2.4.3,1,.7,2.1,1.4,3.1,2.1.3-2.2.5-4,.9-5.8-.5-.3-.9-.6-1.4-.9-.2-.1-.3-.2-.5-.3l-7.4-4.9V39.3Z",
    fill: "#d2d4c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M52.3,90a27.335,27.335,0,0,0,0-7c-.8.7-1.7,1.4-2.5,2.1a103.273,103.273,0,0,0-6.6-11A137.391,137.391,0,0,1,61,60.8c2.1-1.3,4.3-2.6,6.4-3.8a28.1,28.1,0,0,1-.1-2.9,27.15,27.15,0,0,1,.1-2.9c-2.2-1.2-4.3-2.5-6.4-3.8A137.391,137.391,0,0,1,43.2,34.1a110.384,110.384,0,0,0,6.6-11c.8.7,1.7,1.4,2.5,2.1a32.76,32.76,0,0,0,0-7,16.6,16.6,0,0,1-1.4-1.3L48,14.2l-1.6,3.5a94.368,94.368,0,0,1-9,15.3l-1.2,1.7,1.6,1.5A134.7,134.7,0,0,0,60.5,53a16.179,16.179,0,0,0,1.8,1c-.6.3-1.2.7-1.8,1A149.666,149.666,0,0,0,37.7,71.9l-1.6,1.5,1.2,1.7a98.839,98.839,0,0,1,9,15.3l1.6,3.5,2.9-2.7C51.4,90.8,51.8,90.4,52.3,90Z",
    fill: "#d2d4c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M43.3,45.6C34,50.7,9.7,53.8,4.7,54.1c5,.3,29.3,3.4,38.6,8.5,1.4-1.2,2.8-2.3,4.3-3.4a35.152,35.152,0,0,0-11.5-5.1A37.117,37.117,0,0,0,47.6,49C46.1,47.9,44.7,46.8,43.3,45.6Z",
    fill: "#d2d4c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M64.9,34.5l7.4,4.9V68.9l-7.4,4.9c-.2.1-.3.2-.5.3-.5.3-.9.6-1.4.9a41.768,41.768,0,0,1,.9,5.8c1-.7,2.1-1.4,3.1-2.1.1-.1.3-.2.4-.3l10.4-6.9V36.8L67.4,29.9c-.1-.1-.3-.2-.4-.3-1-.7-2.1-1.4-3.1-2.1-.3,2.2-.5,4-.9,5.8.5.3.9.6,1.4.9A2.186,2.186,0,0,0,64.9,34.5Z",
    fill: "#d2d4c2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1850",
    "data-name": "Group 1850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M289.6,73.8a26.936,26.936,0,0,1,1.6-2.9c-1.4-1.1-2.9-2.3-4.3-3.4a27.573,27.573,0,0,0-2.5,4.4,28.5,28.5,0,0,0,2.4,27.5c-.8,1.3-1.8,2.5-2.7,3.7H59a31.755,31.755,0,0,1-2.7-3.7,28.5,28.5,0,0,0,2.4-27.5,27.573,27.573,0,0,0-2.5-4.4c-1.4,1.1-2.9,2.3-4.3,3.4a16.408,16.408,0,0,1,1.6,2.9,24.129,24.129,0,0,1-2.8,24.1l-1,1.3.9,1.4a52.878,52.878,0,0,0,5.7,7.5H286.9a67.387,67.387,0,0,0,5.7-7.5l.9-1.4-1-1.3A23.918,23.918,0,0,1,289.6,73.8Z",
    fill: "#d2d4c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M270.1,22.3c.7-.5,1.4-.9,2-1.4a30.725,30.725,0,0,1,1.4-6.7H69.6A39.956,39.956,0,0,1,71,20.9c.6.4,1.3.9,2,1.4l15,10V76L73,85.8c-.7.5-1.4.9-2.1,1.4a30.723,30.723,0,0,1-1.4,6.7H273.4a39.953,39.953,0,0,1-1.4-6.7c-.7-.5-1.4-1-2-1.4l-15-10V32.2Z",
    fill: "#d2d4c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M53.4,34.3a26.938,26.938,0,0,1-1.6,2.9c1.4,1.1,2.9,2.3,4.3,3.4a27.573,27.573,0,0,0,2.5-4.4A28.5,28.5,0,0,0,56.2,8.7C57.1,7.5,58,6.3,59,5.1H284.1a31.757,31.757,0,0,1,2.7,3.7,28.5,28.5,0,0,0-2.4,27.5,27.573,27.573,0,0,0,2.5,4.4c1.4-1.1,2.9-2.3,4.3-3.4a16.408,16.408,0,0,1-1.6-2.9,24.129,24.129,0,0,1,2.8-24.1l1-1.3-.9-1.4A52.878,52.878,0,0,0,286.8.1H56.2a67.386,67.386,0,0,0-5.7,7.5L49.6,9l1,1.3A23.945,23.945,0,0,1,53.4,34.3Z",
    fill: "#d2d4c2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleDecoration);
export default __webpack_public_path__ + "static/media/sale_decoration.f4d805112d2fce1e1769011788c582ca.svg";
export { ForwardRef as ReactComponent };